// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order_newpageContent__1Eat\\+ {
    display: flex;
    justify-content: space-between;
    margin-top: 0;
    /* min-height: calc(100vh - 67px); */
    min-height: 100vh;
}

.order_newpageRight__l6P9v {
    border-left: 1px solid #e6e6e6;
    margin-top: 0;
    max-height: calc(100vh - 67px);
    /* min-height: 100vh; */
    padding: 0;
    overflow-y: auto;
    position: relative;
    width: 410px;
}

.order_newpageLeft__8CK27 {
    max-height: calc(100dvh - 100px);
    overflow-y: auto;
    /* margin-right: 36px; */
    padding-right: 36px;
    padding-left: 36px;
    width: calc(100% - 410px);
    padding-top: 30px;
}

.order_newpageRight__l6P9v>.order_newPageRightRow__n8CzK {
    border-bottom: 1px solid #e6e6e6;
    border-top: 0;
    overflow: hidden;
    padding: 20px 30px;
}

.order_newpageRight__l6P9v>.order_newPageRightRow__n8CzK.order_sendMailOrderDropdown__Faaau:has(.order_expanded__U0z\\+3),
.order_newpageRight__l6P9v>.order_newPageRightRow__n8CzK.order_sendMailOrderDropdown__Faaau:has(.order_expanded__U0z\\+3) .order_contentDrop__n6ew7 {
    overflow: visible;
}

.order_sendMailOrderDropdown__Faaau .order_addBtn__N7WAZ {
    flex: 1 1;
    height: 39px;
}

.order_sendMailOrderDropdown__Faaau .order_customerNotificationButton__ULgYK .order_addBtn__N7WAZ {
    width: 152.7px;
    height: 39px;
    flex: none;
}

.order_buttonsDesktop__oEUYf {
    border-bottom: 1px solid #e6e6e6;
    padding: 20px 30px;
    display: block;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 2;
}

.order_orderDatatableList__2rcbW {
    padding: 30px 30px 0;
}

.order_orderDetailPageTopBar__JKkRk {
    display: flex;
    gap: 15px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    flex-wrap: wrap;
}

.order_buttonGroup__cMWDo {
    display: flex;
    gap: 10px;
    align-items: center;
}

.order_orderDetailPageTopBar__JKkRk img {
    cursor: pointer;
}

.order_orderHeader__Q5xAr {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.order_orderHeader__Q5xAr .order_leftSide__pD-5g {
    display: flex;
    gap: 20px;
}

.order_searchBar__YSy4P {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 8px 12px;
    gap: 8px;
    min-width: 250px;
    height: 40px;
}

.order_searchBar__YSy4P img {
    width: 16px;
    height: 16px;
}

.order_searchBar__YSy4P input {
    border: none;
    background: transparent;
    outline: none;
    flex: 1 1;
    font-size: 14px;
    color: #333;
}

.order_searchBar__YSy4P input::placeholder {
    color: #999;
}

.order_productAddSection__QjoaV {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #f4f4f4;
    border-top: 0;
}

.order_orderHeader__Q5xAr .order_orderHeading__zQiy7 {
    font-size: 20px;
    font-weight: 600;
}

.order_addBtn__N7WAZ {
    background: #000;
    color: white;
    padding: 10px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
}

.order_addBtn__N7WAZ p {
    margin: 0;
}

.order_productAddBtn__oXpaV {
    background: var(--white);
    color: var(--cloudburst);
    padding: 10px 18px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
}

.order_actionButtonsDeleteAdd__Jcn\\+1 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.order_productsTableFooter__95Apa {
    background-color: #f4f4f4;
}

.order_productsTableFooter__95Apa tr {
    border-bottom: 1px solid #e5e5e5;
}

.order_productsTable__rEadG .order_productsTableFooter__95Apa td {
    border-bottom: 0;
}

.order_deleteSelectedBtn__srET5 {
    cursor: pointer;
}

/* WordPress Admin Style Order Detail */
/* .orderDetail {
    background: #f1f1f1;
    min-height: 100vh;
} */

.order_container__h9xBp {
    padding: 20px;
}

.order_title__GJTyh {
    font-size: 23px;
    font-weight: 400;
    margin-bottom: 20px;
    color: #23282d;
    padding: 0;
    margin: 0;
}

.order_section__s3iYl {
    margin-bottom: 20px;
    flex: 1 1;
}

.order_sectionTitle__zR0NV {
    font-size: 14px;
    font-weight: 600;
    padding: 12px 0 0;
    margin: 0;
    letter-spacing: 0.5px;
}

.order_sectionTitle__zR0NV img {
    cursor: pointer;
}

.order_addressSection__dHx2n .order_sectionTitle__zR0NV {
    display: flex;
    justify-content: space-between;
}

.order_generalGrid__HEcYQ {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px 0;
}

.order_addressGrid__q7F6C {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 0 20px;
    padding: 0 0 20px;
}

.order_customerInputs__-qosK {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.order_field__fz2-c {
    display: flex;
    flex-direction: column;
}

.order_label__oOtCF {
    font-size: 13px;
    font-weight: 600;
    color: #23282d;
    margin-bottom: 5px;
    letter-spacing: 0.5px;
}

.order_value__UMFp9 {
    font-size: 14px;
    color: #50575e;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.order_input__gbgCu,
.order_select__bWiT9 {
    padding: 8px 12px;
    height: 45px;
    width: 100%;
    background: #ffffff;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    outline: none;
    font-size: 14px;
}

/* .input:focus, .select:focus {
    outline: none;
    border-color: #007cba;
    box-shadow: 0 0 0 1px #007cba;
} */

.order_select__bWiT9 {
    cursor: pointer;
}

.order_productsTable__rEadG {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
    border: 1px solid #e5e5e5;
    border-bottom: 0;
}

.order_productsTable__rEadG th {
    color: #23282d;
    font-size: 13px;
    font-weight: 600;
    text-align: left;
    padding: 12px 16px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    background-color: #f4f4f4;
}

.order_productsTable__rEadG th:nth-child(3),
.order_productsTable__rEadG th:nth-child(4),
.order_productsTable__rEadG th:nth-child(5) {
    width: 90px;
    text-align: left;
}

/* .productsTable th:nth-child(7),
.productsTable td:nth-child(7) {
    width: 120px;
} */

.order_productsTable__rEadG td {
    padding: 12px 16px;
    /* border-bottom: 1px solid #e5e5e5; */
    font-size: 14px;
    color: #23282d;
}

.order_productsTable__rEadG tr {
    border-bottom: 1px solid #e5e5e5;
}

.order_productsTable__rEadG td:nth-child(3).order_totalAmountWithDiscount__j6j7- {
    width: 270px;
    text-align: left;
}

.order_totalAmountWithDiscount__j6j7- {
    text-align: right;
}

.order_totalAmountWithDiscount__j6j7- .order_totalInput__hWW0J {
    width: 100%;
    min-width: 100px;
}

.order_totalAmountWithDiscountDiv__6HZWI {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    gap: 6px;
}

.order_totalRow__t-7rb {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.order_label__oOtCF {
    font-weight: 600;
}

.order_footerValue__pdpWe {
    text-align: right;
    min-width: 110px;
}

.order_totalInput__hWW0J {
    width: 100px;
}

.order_productsTable__rEadG td:nth-child(3) {
    width: 120px;
    text-align: left;
}

.order_productsTable__rEadG td:nth-child(4),
.order_productsTable__rEadG td:nth-child(3),
.order_productsTable__rEadG td:nth-child(5),
.order_productsTable__rEadG th:nth-child(3),
.order_productsTable__rEadG th:nth-child(4),
.order_productsTable__rEadG th:nth-child(5) {
    width: 90px;
    text-align: left;
}

.order_actionButtons__i5ICd {
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 0 12px;
}

.order_actionButton__HkpDq {
    border-radius: 5px;
    border: none;
    cursor: pointer;
    background-color: var(--white);
    padding: 0;
    min-width: 20px;
}

/* .productsTable tr:hover {
    background: #f8f9fa;
} */

/* .totalCell {
    cursor: pointer;
    transition: background-color 0.2s;
} */

/* .totalCell:hover {
    background: #f0f8ff;
} */

.order_totalInput__hWW0J,
.order_qtyInput__7Fkg5 {
    /* width: 100%; */
    box-sizing: border-box;
    font-size: 14px;
    padding: 6px 8px;
    border: 1px solid #000;
    border-radius: 4px;
    background: #fff;
    color: #23282d;
}

.order_qtyInput__7Fkg5 {
    width: 60px;
}

.order_totalInput__hWW0J:focus,
.order_qtyInput__7Fkg5:focus {
    outline: none;
}

.order_productsTable__rEadG .order_totalAmount__ZWSGC {
    padding: 16px;
    border-top: 1px solid #e5e5e5;
    text-align: right;
    font-size: 16px;
    color: #23282d;
    background-color: #f4f4f4;
}

.order_orderDetailSection__GPNMe,
.order_addressSection__dHx2n {
    display: flex;
    width: 100%;
    gap: 20px;
}

.order_addressSection__dHx2n {
    gap: 30px;
}

.order_addressBox__\\+YPMg {
    flex: 1 1;
    margin-top: 15px;
}

.order_addressBox__\\+YPMg .order_label__oOtCF {
    font-size: 13px;
    color: #888;
    margin: 0;
}

.order_addressBox__\\+YPMg .order_value__UMFp9 {
    font-size: 13px;
    color: #bbb;
    margin-top: 3px;
    padding: 0;
    background-color: transparent;
    border: 0;
}

.order_dateTimeWrapper__f2OGr {
    display: flex;
    gap: 8px;
    align-items: center;
}

.order_timeInput__zPgRV {
    width: 60px;
    padding: 8px;
}

.order_newpageRightButtons__lm7RZ {
    display: inline-flex;
    position: relative;
    height: 44px;
}

.order_newpageRightButtons__lm7RZ button {
    font-family: 'CyGrotesk-KeyRegular';
}

.order_newpageRightButtons__lm7RZ button:first-child {
    border-radius: 6px;
}

.order_newpageRightButtons__lm7RZ button:first-child {
    border-radius: 4px;
    background: #0a0a0a;
}

.order_newpageRightButtons__lm7RZ button:first-child {
    /* background: #0a0a0a; */
    margin-right: 8px;
    /* min-width: 69px; */
    min-height: 42px;
    position: relative;
    justify-content: center;
    border-radius: 6px !important;
}

.order_newpageRightButtons__lm7RZ .order_publishButton__8I8cB {
    width: 97.3px;
}

.order_newpageRightButtons__lm7RZ button {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    display: flex;
    gap: 8px;
    /* border-radius: 6px; */
    align-items: center;
    padding: 10px;
    /* border: none; */
    /* color: #fff; */
    cursor: pointer;
}

.order_newpageRightButtons__lm7RZ button:nth-child(2) {
    margin-right: 8px;
}

.order_buttonsMobile__K6jYV {
    border-bottom: 1px solid #e6e6e6;
    padding: 20px 30px;
    display: none;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 2;
}

.order_newPageRightTitle__m4sFF {
    color: #344054;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
}

.order_iconDropWrap__GMPya {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    margin: 0;
}

.order_iconDropWrap__GMPya span {
    font-weight: 500;
    margin-right: 3px;
    width: calc(100% - 15px);
    display: block;
}

.order_newPageRight__vuQFu:has(.order_expanded__U0z\\+3) .order_dropdownIcon__1Gv-g,
.order_newPageRightRow__n8CzK:has(.order_expanded__U0z\\+3) .order_dropdownIcon__1Gv-g {
    transform: rotate(-180deg);
}

.order_dropdownIcon__1Gv-g {
    transition: all 0.2s linear;
    width: 12px;
}

.order_expanded__U0z\\+3 {
    max-height: 1000px;
    transition: max-height 0.8s ease-in-out 0s;
    overflow: hidden;
}

.order_newpageRight__l6P9v>.order_desktopFeatures__MhqGk:has(.order_expanded__U0z\\+3) {
    border-color: transparent;
}

.order_collapse__Onwy5 {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.6s ease-in-out 0s;
}

.order_contentDrop__n6ew7 {
    overflow: hidden;
}

.order_adressInputBlock__LC-Ht {
    position: relative;
}

.order_urlInput__3pxFy {
    margin-top: 15px;
    display: flex;
    width: 100%;
    align-items: center;
    gap: 10px;
}

.order_orderNotesWrapper__QF5Kb {
    padding: 15px 0 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.order_driverMobileWrapper__S9Riy {
    padding: 15px 0 0;
    display: flex;
    flex-direction: column;
    gap: 0;
}

.order_deliveryVerificationBtn__AY\\+tL {
    width: 162.16px;
    margin-top: 15px;
}

.order_orderNoteBox__Vaa9V {
    background: #f2f2f2;
    padding: 12px;
    border-radius: 6px;
}

.order_noteMessage__usspp {
    color: #333;
    font-size: 14px;
    margin-bottom: 6px;
    margin-top: 0;
}

.order_noteDate__9ENnX {
    font-size: 12px;
    color: #777;
    margin-bottom: 8px;
}

.order_deleteNote__N3eGv {
    color: #d00;
    font-size: 12px;
    cursor: pointer;
    margin: 0;
}

.order_discountSection__ieNC1 {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.order_discountSection__ieNC1 div,
.order_discountSection__ieNC1 label {
    cursor: pointer;
}

.order_discountSection__ieNC1 label span {
    font-size: 14px;
}

.order_radioButtonGroup__QT-\\+R {
    display: flex;
    align-items: center;
    gap: 5px;
}

.order_updateOrderbtn__KvuPP {
    width: 74.83px;
}

.order_addOrderBtn__rB6oW {
    width: 55.41px;
}

/* Order Image Upload By User Section */
.order_orderImageWrapper__f6uyx {
    padding: 15px 0 0;
    display: flex;
    justify-content: center;
}

.order_orderUserImage__DK9R7 {
    width: 100%;
    max-height: 200px;
    object-fit: contain;
    border-radius: 8px;
    cursor: pointer;
    border: 2px solid #e6e6e6;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.order_noImageText__sVKhu {
    padding: 15px 0 0;
    color: #777;
    font-size: 14px;
    font-style: italic;
}

/* Image Popup Styles */
.order_imagePopupOverlay__djrx4 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: order_fadeIn__LuarN 0.2s ease-out;
}

@keyframes order_fadeIn__LuarN {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.order_imagePopupContent__ufLH5 {
    position: relative;
    max-width: 90vw;
    max-height: 90vh;
    animation: order_scaleIn__G1SIi 0.2s ease-out;
}

@keyframes order_scaleIn__G1SIi {
    from {
        transform: scale(0.9);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

.order_imagePopupImage__uNxZk {
    max-width: 100%;
    max-height: 85vh;
    object-fit: contain;
    border-radius: 8px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);
}

.order_imagePopupClose__HqzV3 {
    position: absolute;
    top: 5px;
    right: 5px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    transition: transform 0.2s ease;
}

.order_imagePopupClose__HqzV3:hover {
    transform: scale(1.1);
}

.order_imagePopupClose__HqzV3 img {
    filter: brightness(0) invert(1);
}

@media screen and (max-width: 1650px) {
    .order_orderDetailSection__GPNMe {
        flex-wrap: wrap;
    }
}

@media screen and (max-width: 1260px) {
    .order_newpageContent__1Eat\\+ {
        margin-top: 30px;
        flex-direction: column;
    }

    .order_newpageRight__l6P9v,
    .order_newpageLeft__8CK27 {
        width: 100%;
        max-height: 100%
    }

    .order_buttonsDesktop__oEUYf {
        display: none;
    }

    .order_buttonsMobile__K6jYV {
        display: block;
    }

    .order_newpageLeft__8CK27 {
        padding-right: 36px;
        padding-top: 0px;
    }

}

@media screen and (max-width: 1024px) {
    .order_orderDetailSection__GPNMe {
        flex-wrap: nowrap;
    }
}

@media screen and (max-width: 768px) {

    .order_orderDetailSection__GPNMe,
    .order_addressSection__dHx2n {
        flex-wrap: wrap;
    }

    .order_addressSection__dHx2n {
        flex-wrap: wrap;
        gap: 10px;
    }

    .order_generalGrid__HEcYQ,
    .order_addressGrid__q7F6C {
        padding-bottom: 0;
        padding-top: 10px;
    }

    .order_actionButtonsDeleteAdd__Jcn\\+1 {
        justify-content: space-between;
        width: 100%;
    }

    .order_searchBar__YSy4P,
    .order_leftSide__pD-5g {
        width: calc(100% - 50px);
        min-width: calc(100% - 50px)
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Orders/order.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,MAAM;IACN,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,SAAO;IACP,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA,uCAAuC;AACvC;;;GAGG;;AAEH;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;;;;GAIG;;AAEH;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;;IAGI,WAAW;IACX,gBAAgB;AACpB;;AAEA;;;GAGG;;AAEH;IACI,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;;;;;IAMI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,UAAU;IACV,eAAe;AACnB;;AAEA;;GAEG;;AAEH;;;GAGG;;AAEH;;GAEG;;AAEH;;IAEI,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;IACb,WAAW;IACX,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAS;AACb;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,UAAU;IACV,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,MAAM;IACN,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,MAAM;AACV;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,uCAAuC;AACvC;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,4CAA+B;AACnC;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,6CAAgC;AACpC;;AAEA;IACI;QACI,qBAAqB;QACrB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;QACX;IACJ;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;AAEJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;;QAEI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,8BAA8B;QAC9B,WAAW;IACf;;IAEA;;QAEI,wBAAwB;QACxB;IACJ;AACJ","sourcesContent":[".newpageContent {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 0;\n    /* min-height: calc(100vh - 67px); */\n    min-height: 100vh;\n}\n\n.newpageRight {\n    border-left: 1px solid #e6e6e6;\n    margin-top: 0;\n    max-height: calc(100vh - 67px);\n    /* min-height: 100vh; */\n    padding: 0;\n    overflow-y: auto;\n    position: relative;\n    width: 410px;\n}\n\n.newpageLeft {\n    max-height: calc(100dvh - 100px);\n    overflow-y: auto;\n    /* margin-right: 36px; */\n    padding-right: 36px;\n    padding-left: 36px;\n    width: calc(100% - 410px);\n    padding-top: 30px;\n}\n\n.newpageRight>.newPageRightRow {\n    border-bottom: 1px solid #e6e6e6;\n    border-top: 0;\n    overflow: hidden;\n    padding: 20px 30px;\n}\n\n.newpageRight>.newPageRightRow.sendMailOrderDropdown:has(.expanded),\n.newpageRight>.newPageRightRow.sendMailOrderDropdown:has(.expanded) .contentDrop {\n    overflow: visible;\n}\n\n.sendMailOrderDropdown .addBtn {\n    flex: 1;\n    height: 39px;\n}\n\n.sendMailOrderDropdown .customerNotificationButton .addBtn {\n    width: 152.7px;\n    height: 39px;\n    flex: none;\n}\n\n.buttonsDesktop {\n    border-bottom: 1px solid #e6e6e6;\n    padding: 20px 30px;\n    display: block;\n    position: sticky;\n    top: 0;\n    background-color: #fff;\n    z-index: 2;\n}\n\n.orderDatatableList {\n    padding: 30px 30px 0;\n}\n\n.orderDetailPageTopBar {\n    display: flex;\n    gap: 15px;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n}\n\n.buttonGroup {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.orderDetailPageTopBar img {\n    cursor: pointer;\n}\n\n.orderHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.orderHeader .leftSide {\n    display: flex;\n    gap: 20px;\n}\n\n.searchBar {\n    display: flex;\n    align-items: center;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 8px 12px;\n    gap: 8px;\n    min-width: 250px;\n    height: 40px;\n}\n\n.searchBar img {\n    width: 16px;\n    height: 16px;\n}\n\n.searchBar input {\n    border: none;\n    background: transparent;\n    outline: none;\n    flex: 1;\n    font-size: 14px;\n    color: #333;\n}\n\n.searchBar input::placeholder {\n    color: #999;\n}\n\n.productAddSection {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background-color: #f4f4f4;\n    border-top: 0;\n}\n\n.orderHeader .orderHeading {\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.addBtn {\n    background: #000;\n    color: white;\n    padding: 10px;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.addBtn p {\n    margin: 0;\n}\n\n.productAddBtn {\n    background: var(--white);\n    color: var(--cloudburst);\n    padding: 10px 18px;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.actionButtonsDeleteAdd {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.productsTableFooter {\n    background-color: #f4f4f4;\n}\n\n.productsTableFooter tr {\n    border-bottom: 1px solid #e5e5e5;\n}\n\n.productsTable .productsTableFooter td {\n    border-bottom: 0;\n}\n\n.deleteSelectedBtn {\n    cursor: pointer;\n}\n\n/* WordPress Admin Style Order Detail */\n/* .orderDetail {\n    background: #f1f1f1;\n    min-height: 100vh;\n} */\n\n.container {\n    padding: 20px;\n}\n\n.title {\n    font-size: 23px;\n    font-weight: 400;\n    margin-bottom: 20px;\n    color: #23282d;\n    padding: 0;\n    margin: 0;\n}\n\n.section {\n    margin-bottom: 20px;\n    flex: 1;\n}\n\n.sectionTitle {\n    font-size: 14px;\n    font-weight: 600;\n    padding: 12px 0 0;\n    margin: 0;\n    letter-spacing: 0.5px;\n}\n\n.sectionTitle img {\n    cursor: pointer;\n}\n\n.addressSection .sectionTitle {\n    display: flex;\n    justify-content: space-between;\n}\n\n.generalGrid {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    padding: 20px 0;\n}\n\n.addressGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 0 20px;\n    padding: 0 0 20px;\n}\n\n.customerInputs {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.field {\n    display: flex;\n    flex-direction: column;\n}\n\n.label {\n    font-size: 13px;\n    font-weight: 600;\n    color: #23282d;\n    margin-bottom: 5px;\n    letter-spacing: 0.5px;\n}\n\n.value {\n    font-size: 14px;\n    color: #50575e;\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n}\n\n.input,\n.select {\n    padding: 8px 12px;\n    height: 45px;\n    width: 100%;\n    background: #ffffff;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    outline: none;\n    font-size: 14px;\n}\n\n/* .input:focus, .select:focus {\n    outline: none;\n    border-color: #007cba;\n    box-shadow: 0 0 0 1px #007cba;\n} */\n\n.select {\n    cursor: pointer;\n}\n\n.productsTable {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 15px;\n    border: 1px solid #e5e5e5;\n    border-bottom: 0;\n}\n\n.productsTable th {\n    color: #23282d;\n    font-size: 13px;\n    font-weight: 600;\n    text-align: left;\n    padding: 12px 16px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    background-color: #f4f4f4;\n}\n\n.productsTable th:nth-child(3),\n.productsTable th:nth-child(4),\n.productsTable th:nth-child(5) {\n    width: 90px;\n    text-align: left;\n}\n\n/* .productsTable th:nth-child(7),\n.productsTable td:nth-child(7) {\n    width: 120px;\n} */\n\n.productsTable td {\n    padding: 12px 16px;\n    /* border-bottom: 1px solid #e5e5e5; */\n    font-size: 14px;\n    color: #23282d;\n}\n\n.productsTable tr {\n    border-bottom: 1px solid #e5e5e5;\n}\n\n.productsTable td:nth-child(3).totalAmountWithDiscount {\n    width: 270px;\n    text-align: left;\n}\n\n.totalAmountWithDiscount {\n    text-align: right;\n}\n\n.totalAmountWithDiscount .totalInput {\n    width: 100%;\n    min-width: 100px;\n}\n\n.totalAmountWithDiscountDiv {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: center;\n    gap: 6px;\n}\n\n.totalRow {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.label {\n    font-weight: 600;\n}\n\n.footerValue {\n    text-align: right;\n    min-width: 110px;\n}\n\n.totalInput {\n    width: 100px;\n}\n\n.productsTable td:nth-child(3) {\n    width: 120px;\n    text-align: left;\n}\n\n.productsTable td:nth-child(4),\n.productsTable td:nth-child(3),\n.productsTable td:nth-child(5),\n.productsTable th:nth-child(3),\n.productsTable th:nth-child(4),\n.productsTable th:nth-child(5) {\n    width: 90px;\n    text-align: left;\n}\n\n.actionButtons {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    gap: 0 12px;\n}\n\n.actionButton {\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n    background-color: var(--white);\n    padding: 0;\n    min-width: 20px;\n}\n\n/* .productsTable tr:hover {\n    background: #f8f9fa;\n} */\n\n/* .totalCell {\n    cursor: pointer;\n    transition: background-color 0.2s;\n} */\n\n/* .totalCell:hover {\n    background: #f0f8ff;\n} */\n\n.totalInput,\n.qtyInput {\n    /* width: 100%; */\n    box-sizing: border-box;\n    font-size: 14px;\n    padding: 6px 8px;\n    border: 1px solid #000;\n    border-radius: 4px;\n    background: #fff;\n    color: #23282d;\n}\n\n.qtyInput {\n    width: 60px;\n}\n\n.totalInput:focus,\n.qtyInput:focus {\n    outline: none;\n}\n\n.productsTable .totalAmount {\n    padding: 16px;\n    border-top: 1px solid #e5e5e5;\n    text-align: right;\n    font-size: 16px;\n    color: #23282d;\n    background-color: #f4f4f4;\n}\n\n.orderDetailSection,\n.addressSection {\n    display: flex;\n    width: 100%;\n    gap: 20px;\n}\n\n.addressSection {\n    gap: 30px;\n}\n\n.addressBox {\n    flex: 1;\n    margin-top: 15px;\n}\n\n.addressBox .label {\n    font-size: 13px;\n    color: #888;\n    margin: 0;\n}\n\n.addressBox .value {\n    font-size: 13px;\n    color: #bbb;\n    margin-top: 3px;\n    padding: 0;\n    background-color: transparent;\n    border: 0;\n}\n\n.dateTimeWrapper {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.timeInput {\n    width: 60px;\n    padding: 8px;\n}\n\n.newpageRightButtons {\n    display: inline-flex;\n    position: relative;\n    height: 44px;\n}\n\n.newpageRightButtons button {\n    font-family: 'CyGrotesk-KeyRegular';\n}\n\n.newpageRightButtons button:first-child {\n    border-radius: 6px;\n}\n\n.newpageRightButtons button:first-child {\n    border-radius: 4px;\n    background: #0a0a0a;\n}\n\n.newpageRightButtons button:first-child {\n    /* background: #0a0a0a; */\n    margin-right: 8px;\n    /* min-width: 69px; */\n    min-height: 42px;\n    position: relative;\n    justify-content: center;\n    border-radius: 6px !important;\n}\n\n.newpageRightButtons .publishButton {\n    width: 97.3px;\n}\n\n.newpageRightButtons button {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 22px;\n    display: flex;\n    gap: 8px;\n    /* border-radius: 6px; */\n    align-items: center;\n    padding: 10px;\n    /* border: none; */\n    /* color: #fff; */\n    cursor: pointer;\n}\n\n.newpageRightButtons button:nth-child(2) {\n    margin-right: 8px;\n}\n\n.buttonsMobile {\n    border-bottom: 1px solid #e6e6e6;\n    padding: 20px 30px;\n    display: none;\n    position: sticky;\n    top: 0;\n    background-color: #fff;\n    z-index: 2;\n}\n\n.newPageRightTitle {\n    color: #344054;\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 500;\n}\n\n.iconDropWrap {\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    margin: 0;\n}\n\n.iconDropWrap span {\n    font-weight: 500;\n    margin-right: 3px;\n    width: calc(100% - 15px);\n    display: block;\n}\n\n.newPageRight:has(.expanded) .dropdownIcon,\n.newPageRightRow:has(.expanded) .dropdownIcon {\n    transform: rotate(-180deg);\n}\n\n.dropdownIcon {\n    transition: all 0.2s linear;\n    width: 12px;\n}\n\n.expanded {\n    max-height: 1000px;\n    transition: max-height 0.8s ease-in-out 0s;\n    overflow: hidden;\n}\n\n.newpageRight>.desktopFeatures:has(.expanded) {\n    border-color: transparent;\n}\n\n.collapse {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.6s ease-in-out 0s;\n}\n\n.contentDrop {\n    overflow: hidden;\n}\n\n.adressInputBlock {\n    position: relative;\n}\n\n.urlInput {\n    margin-top: 15px;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    gap: 10px;\n}\n\n.orderNotesWrapper {\n    padding: 15px 0 0;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.driverMobileWrapper {\n    padding: 15px 0 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n}\n\n.deliveryVerificationBtn {\n    width: 162.16px;\n    margin-top: 15px;\n}\n\n.orderNoteBox {\n    background: #f2f2f2;\n    padding: 12px;\n    border-radius: 6px;\n}\n\n.noteMessage {\n    color: #333;\n    font-size: 14px;\n    margin-bottom: 6px;\n    margin-top: 0;\n}\n\n.noteDate {\n    font-size: 12px;\n    color: #777;\n    margin-bottom: 8px;\n}\n\n.deleteNote {\n    color: #d00;\n    font-size: 12px;\n    cursor: pointer;\n    margin: 0;\n}\n\n.discountSection {\n    margin-top: 15px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.discountSection div,\n.discountSection label {\n    cursor: pointer;\n}\n\n.discountSection label span {\n    font-size: 14px;\n}\n\n.radioButtonGroup {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.updateOrderbtn {\n    width: 74.83px;\n}\n\n.addOrderBtn {\n    width: 55.41px;\n}\n\n/* Order Image Upload By User Section */\n.orderImageWrapper {\n    padding: 15px 0 0;\n    display: flex;\n    justify-content: center;\n}\n\n.orderUserImage {\n    width: 100%;\n    max-height: 200px;\n    object-fit: contain;\n    border-radius: 8px;\n    cursor: pointer;\n    border: 2px solid #e6e6e6;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.noImageText {\n    padding: 15px 0 0;\n    color: #777;\n    font-size: 14px;\n    font-style: italic;\n}\n\n/* Image Popup Styles */\n.imagePopupOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, .5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n    animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.imagePopupContent {\n    position: relative;\n    max-width: 90vw;\n    max-height: 90vh;\n    animation: scaleIn 0.2s ease-out;\n}\n\n@keyframes scaleIn {\n    from {\n        transform: scale(0.9);\n        opacity: 0;\n    }\n\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n.imagePopupImage {\n    max-width: 100%;\n    max-height: 85vh;\n    object-fit: contain;\n    border-radius: 8px;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);\n}\n\n.imagePopupClose {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 8px;\n    transition: transform 0.2s ease;\n}\n\n.imagePopupClose:hover {\n    transform: scale(1.1);\n}\n\n.imagePopupClose img {\n    filter: brightness(0) invert(1);\n}\n\n@media screen and (max-width: 1650px) {\n    .orderDetailSection {\n        flex-wrap: wrap;\n    }\n}\n\n@media screen and (max-width: 1260px) {\n    .newpageContent {\n        margin-top: 30px;\n        flex-direction: column;\n    }\n\n    .newpageRight,\n    .newpageLeft {\n        width: 100%;\n        max-height: 100%\n    }\n\n    .buttonsDesktop {\n        display: none;\n    }\n\n    .buttonsMobile {\n        display: block;\n    }\n\n    .newpageLeft {\n        padding-right: 36px;\n        padding-top: 0px;\n    }\n\n}\n\n@media screen and (max-width: 1024px) {\n    .orderDetailSection {\n        flex-wrap: nowrap;\n    }\n}\n\n@media screen and (max-width: 768px) {\n\n    .orderDetailSection,\n    .addressSection {\n        flex-wrap: wrap;\n    }\n\n    .addressSection {\n        flex-wrap: wrap;\n        gap: 10px;\n    }\n\n    .generalGrid,\n    .addressGrid {\n        padding-bottom: 0;\n        padding-top: 10px;\n    }\n\n    .actionButtonsDeleteAdd {\n        justify-content: space-between;\n        width: 100%;\n    }\n\n    .searchBar,\n    .leftSide {\n        width: calc(100% - 50px);\n        min-width: calc(100% - 50px)\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newpageContent": `order_newpageContent__1Eat+`,
	"newpageRight": `order_newpageRight__l6P9v`,
	"newpageLeft": `order_newpageLeft__8CK27`,
	"newPageRightRow": `order_newPageRightRow__n8CzK`,
	"sendMailOrderDropdown": `order_sendMailOrderDropdown__Faaau`,
	"expanded": `order_expanded__U0z+3`,
	"contentDrop": `order_contentDrop__n6ew7`,
	"addBtn": `order_addBtn__N7WAZ`,
	"customerNotificationButton": `order_customerNotificationButton__ULgYK`,
	"buttonsDesktop": `order_buttonsDesktop__oEUYf`,
	"orderDatatableList": `order_orderDatatableList__2rcbW`,
	"orderDetailPageTopBar": `order_orderDetailPageTopBar__JKkRk`,
	"buttonGroup": `order_buttonGroup__cMWDo`,
	"orderHeader": `order_orderHeader__Q5xAr`,
	"leftSide": `order_leftSide__pD-5g`,
	"searchBar": `order_searchBar__YSy4P`,
	"productAddSection": `order_productAddSection__QjoaV`,
	"orderHeading": `order_orderHeading__zQiy7`,
	"productAddBtn": `order_productAddBtn__oXpaV`,
	"actionButtonsDeleteAdd": `order_actionButtonsDeleteAdd__Jcn+1`,
	"productsTableFooter": `order_productsTableFooter__95Apa`,
	"productsTable": `order_productsTable__rEadG`,
	"deleteSelectedBtn": `order_deleteSelectedBtn__srET5`,
	"container": `order_container__h9xBp`,
	"title": `order_title__GJTyh`,
	"section": `order_section__s3iYl`,
	"sectionTitle": `order_sectionTitle__zR0NV`,
	"addressSection": `order_addressSection__dHx2n`,
	"generalGrid": `order_generalGrid__HEcYQ`,
	"addressGrid": `order_addressGrid__q7F6C`,
	"customerInputs": `order_customerInputs__-qosK`,
	"field": `order_field__fz2-c`,
	"label": `order_label__oOtCF`,
	"value": `order_value__UMFp9`,
	"input": `order_input__gbgCu`,
	"select": `order_select__bWiT9`,
	"totalAmountWithDiscount": `order_totalAmountWithDiscount__j6j7-`,
	"totalInput": `order_totalInput__hWW0J`,
	"totalAmountWithDiscountDiv": `order_totalAmountWithDiscountDiv__6HZWI`,
	"totalRow": `order_totalRow__t-7rb`,
	"footerValue": `order_footerValue__pdpWe`,
	"actionButtons": `order_actionButtons__i5ICd`,
	"actionButton": `order_actionButton__HkpDq`,
	"qtyInput": `order_qtyInput__7Fkg5`,
	"totalAmount": `order_totalAmount__ZWSGC`,
	"orderDetailSection": `order_orderDetailSection__GPNMe`,
	"addressBox": `order_addressBox__+YPMg`,
	"dateTimeWrapper": `order_dateTimeWrapper__f2OGr`,
	"timeInput": `order_timeInput__zPgRV`,
	"newpageRightButtons": `order_newpageRightButtons__lm7RZ`,
	"publishButton": `order_publishButton__8I8cB`,
	"buttonsMobile": `order_buttonsMobile__K6jYV`,
	"newPageRightTitle": `order_newPageRightTitle__m4sFF`,
	"iconDropWrap": `order_iconDropWrap__GMPya`,
	"newPageRight": `order_newPageRight__vuQFu`,
	"dropdownIcon": `order_dropdownIcon__1Gv-g`,
	"desktopFeatures": `order_desktopFeatures__MhqGk`,
	"collapse": `order_collapse__Onwy5`,
	"adressInputBlock": `order_adressInputBlock__LC-Ht`,
	"urlInput": `order_urlInput__3pxFy`,
	"orderNotesWrapper": `order_orderNotesWrapper__QF5Kb`,
	"driverMobileWrapper": `order_driverMobileWrapper__S9Riy`,
	"deliveryVerificationBtn": `order_deliveryVerificationBtn__AY+tL`,
	"orderNoteBox": `order_orderNoteBox__Vaa9V`,
	"noteMessage": `order_noteMessage__usspp`,
	"noteDate": `order_noteDate__9ENnX`,
	"deleteNote": `order_deleteNote__N3eGv`,
	"discountSection": `order_discountSection__ieNC1`,
	"radioButtonGroup": `order_radioButtonGroup__QT-+R`,
	"updateOrderbtn": `order_updateOrderbtn__KvuPP`,
	"addOrderBtn": `order_addOrderBtn__rB6oW`,
	"orderImageWrapper": `order_orderImageWrapper__f6uyx`,
	"orderUserImage": `order_orderUserImage__DK9R7`,
	"noImageText": `order_noImageText__sVKhu`,
	"imagePopupOverlay": `order_imagePopupOverlay__djrx4`,
	"fadeIn": `order_fadeIn__LuarN`,
	"imagePopupContent": `order_imagePopupContent__ufLH5`,
	"scaleIn": `order_scaleIn__G1SIi`,
	"imagePopupImage": `order_imagePopupImage__uNxZk`,
	"imagePopupClose": `order_imagePopupClose__HqzV3`
};
export default ___CSS_LOADER_EXPORT___;
